import { makeAutoObservable, runInAction } from 'mobx';

import {cmApi } from '@src/api';
import { preloaderStore } from '@stores/preloaderStore';
import type { CmApi, ReportVersionDto } from '@src/api';

import { reportVersionsStore } from '../reportVersionsStore';

class ReportVersionEditStore {
  reportVersion: ReportVersionDto | null;

  isNew = false;

  editMode = false;

  isLoading = false;

  disableEdit = false;

  hiddenEdit = false;

  hiddenDelete = false;

  hiddenClean = false;

  hiddenSave = false;

  api: CmApi;

  constructor({ api }: { api: CmApi }) {
    this.api = api;
    this.reportVersion = null;

    makeAutoObservable(this);
  }

  get isEditMode() {
    return this.editMode || this.isNew;
  }

  setHiddenEdit = (hiddenEdit = true): void => {
    this.hiddenEdit = hiddenEdit;
  };

  setHiddenDelete = (hiddenDelete = true): void => {
    this.hiddenDelete = hiddenDelete;
  };

  setHiddenClean = (hiddenClean = true): void => {
    this.hiddenClean = hiddenClean;
  };

  setHiddenSave = (hiddenSave = true): void => {
    this.hiddenSave = hiddenSave;
  };

  setDisableEdit = (disableEdit = true) => {
    this.disableEdit = disableEdit;
  };

  setNew = (isNew = true) => {
    this.isNew = isNew;
    this.reportVersion = null;
  };

  setEditMode = (editMode = true) => {
    this.editMode = editMode;
  };

  save = async (reportGroup: ReportVersionDto) => {
    preloaderStore.preloader(true);
    const { data } = await (this.isNew
      ? this.api.reportVersions.addReportVersion(reportGroup)
      : this.api.reportVersions.updateReportVersion(reportGroup));

    if (data?.code) {
      reportVersionsStore.setIsChanged(true);

      if (this.isNew) {
        preloaderStore.preloader(false);
        return data.code;
      }
      runInAction(() => {
        this.reportVersion = data;
        this.setEditMode(false);
      });
    }
    preloaderStore.preloader(false);
    return undefined;
  };

  delete = async () => {
    if (this.reportVersion?.code) {
      await this.api.reportVersions.deleteReportVersion([this.reportVersion.code]);
      reportVersionsStore.setIsChanged(true);
    }
  };

  fetch = async (code?: string): Promise<void> => {
    if (!code) {
      return;
    }
    preloaderStore.preloader(true);
    runInAction(() => {
      this.isLoading = true;
      this.setEditMode(false);
      this.setNew(false);
    });

    const { data } = await this.api.reportVersions.getReportVersion(code);

    runInAction(() => {
      this.reportVersion = data;
      this.isLoading = false;
    });
    preloaderStore.preloader(false);
  };
}

export const reportVersionEditStore = new ReportVersionEditStore({ api: cmApi });
